import { render } from "./DashboardCampaignMainMetrics.vue?vue&type=template&id=eebfa076&scoped=true"
import script from "./DashboardCampaignMainMetrics.vue?vue&type=script&lang=js"
export * from "./DashboardCampaignMainMetrics.vue?vue&type=script&lang=js"

import "./DashboardCampaignMainMetrics.vue?vue&type=style&index=0&id=eebfa076&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebfa076"]])

export default __exports__